import Terminal from './Terminal'

export default Terminal;